module.exports = __webpack_public_path__ + "static/media/gold1.dc6c65ad.png";